// Per-route <title> and meta description. Brand comes from the backend (SITE_BRAND_NAME), not from the UI.
const PUBLIC = {
  '/': ['Invite-only land investing', 'Take part in individual land projects held in their own companies. Participation is by invitation.'],
  '/contact': ['Request an invite', 'Request an invite or contact the team.'],
  '/about': ['About', 'Who operates the platform and how it works.'],
  '/faq': ['Frequently asked questions', 'Answers to common questions about fractional land ownership through SPVs.'],
  '/investment-guide': ['Investor guide', 'How investing in a project company works, step by step.'],
  '/risk-disclosure': ['Risk disclosure', 'The risks of investing in land projects. Returns are not guaranteed.'],
  '/terms': ['Terms of service', 'Terms for using the platform.'],
  '/privacy': ['Privacy policy', 'How personal information is collected and used.'],
  '/mca-compliant': ['Corporate information', 'Operator and company registration details.'],
  '/login': ['Log in', 'Log in to your investor account.'],
  '/register': ['Create an account', 'Create an account with your invite code.'],
};
const PRIVATE = {
  '/dashboard': 'Dashboard', '/kyc': 'KYC', '/deals': 'Deals', '/commitments': 'My commitments', '/my-documents': 'Holdings and documents',
  '/payments': 'Payments', '/audit': 'Activity log', '/resale': 'Resale', '/rm/leads': 'Lead pipeline',
};

export function metaFor(pathname, brand) {
  const b = brand || 'FraxLandShare';
  if (PUBLIC[pathname]) return { title: `${PUBLIC[pathname][0]} | ${b}`, description: PUBLIC[pathname][1] };
  const key = Object.keys(PRIVATE).find((k) => pathname === k || pathname.startsWith(`${k}/`));
  if (key) return { title: `${PRIVATE[key]} | ${b}`, description: null };
  if (pathname.startsWith('/admin')) return { title: `Admin | ${b}`, description: null };
  return { title: `Page not found | ${b}`, description: null };
}
